import { useEffect, useState } from "react";
import { CardContent, Grid, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDModal from "components/MDModal";
import { useSearch } from "context/SearchContext";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { useOrderProducts } from "context/OrderProductsContext";

function SearchProduct({ setOrderProduct }) {
  const [isOpen, setIsOpen] = useState(false);
  const { addProductsOrder } = useOrderProducts();

  const { searchProducts, response, setResponse } = useSearch();
  const handleModal = () => setIsOpen(!isOpen);
  const closeSearchModal = () => {
    setResponse([]);
    setIsOpen(false);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm({});
  const search_products = watch("search_products");

  useEffect(() => {
    if (response.length !== 0) setIsOpen(true);
  }, [response]);

  useEffect(() => {
    if (search_products?.length >= 3) {
      searchProducts(search_products);
    }
  }, [search_products]);
  return (
    <Grid>
      <Typography variant="h6" sx={{ color: "#fff", fontWeight: "bold", marginBottom: 1 }}>
        Buscar Produtos:
      </Typography>
      <MDInput
        {...register("search_products")}
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: "4px",
          border: "1px solid #ccc",
        }}
        placeholder={"Pesquise a partir de 3 letras"}
        fullWidth
      />
      <MDModal isOpen={isOpen} handleModal={handleModal}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Buscar Produtos
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          {response.map((data) => (
            <>
              <Grid item xs={10}>
                <Typography
                  variant="h8"
                  onClick={() => {
                    addProductsOrder(data);
                    setIsOpen(!isOpen);
                  }}
                  component="h4"
                >
                  {`Produto: ${data.name}`}
                </Typography>
              </Grid>
            </>
          ))}
        </Typography>
        <MDButton variant="gradient" color="info" onClick={closeSearchModal} fullWidth>
          Fechar
        </MDButton>
      </MDModal>{" "}
    </Grid>
  );
}

SearchProduct.propTypes = {
  setOrderProduct: PropTypes.func,
};

export default SearchProduct;
